import { render, staticRenderFns } from "./TeacherArchivedPage.vue?vue&type=template&id=1483e6af&scoped=true&"
import script from "./TeacherArchivedPage.vue?vue&type=script&lang=js&"
export * from "./TeacherArchivedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1483e6af",
  null
  
)

export default component.exports